import { Button, Icon } from '@zoom/components';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useClipboard } from '../../../../utils/useClipboard';
import { CALENDAR_EXPORT_CONTENT, CALENDAR_EXPORT_COPY_BUTTON, CALENDAR_EXPORT_TOGGLE_BUTTON } from '../../constants';

type CalendarExportProps = {
  url: string;
};

// TODO: For weekly view only in old design. Once weekly view scene will be re-designed this file can be deleted
export const CalendarExportOld: React.FC<CalendarExportProps> = ({ url }) => {
  const { t } = useTranslation();
  const [copied, copy] = useClipboard();

  const handleCopy = () => {
    if (!copy(url)) {
      toast.error(t('layout.somethingWentWrong'));
    }
  };

  return (
    <section
      aria-labelledby={CALENDAR_EXPORT_TOGGLE_BUTTON}
      className="calendar-export"
      data-test-id={CALENDAR_EXPORT_CONTENT}
      id={CALENDAR_EXPORT_CONTENT}
    >
      <div className="calendar-export__content">
        <div>
          <strong>{t('calendar.export.description')}</strong>{' '}
          <span className="calendar-export__warning">{t('calendar.export.warning')}</span>
        </div>
        <input className="calendar-export__url" value={url} readOnly />
      </div>
      <Button
        active={copied}
        className={classnames('calendar-export__copy-button', { 'button--icon--left-hand-side': copied })}
        color={copied ? 'info' : 'primary'}
        data-test-id={CALENDAR_EXPORT_COPY_BUTTON}
        onClick={handleCopy}
      >
        {copied ? (
          <>
            <Icon kind="checkmark" color="#239ed8" size={20} />
            {t('layout.action.copyClipboard.successMessage')}
          </>
        ) : (
          t('layout.action.copyClipboard.title')
        )}
      </Button>
    </section>
  );
};
